const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = 'nexora.devtoken';

export const devToken = {
  get: () => localStorage.getItem(KEY),
  set: (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY)),
};

export function authHeaders(extra = {}) {
  const t = devToken.get();
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Bearer ${t}` } : {}), ...extra };
}

function detail(j, status) {
  const d = j?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return `Errore ${status}`;
}

export async function api(path, { method = 'GET', body, auth = false, timeout = 0 } = {}) {
  const ctrl = new AbortController();
  const t = timeout ? setTimeout(() => ctrl.abort(), timeout) : null;
  const pt = localStorage.getItem('titan.player');
  try {
    const headers = { ...(auth ? authHeaders() : { 'Content-Type': 'application/json' }), ...(pt ? { 'X-Player-Token': pt } : {}) };
    const res = await fetch(`${API}${path}`, { method, headers, body: body ? JSON.stringify(body) : undefined, signal: ctrl.signal });
    const j = await res.json().catch(() => ({}));
    if (res.status === 401 && auth) window.dispatchEvent(new Event('titan:unauth'));
    if (!res.ok) { const e = new Error(detail(j, res.status)); e.status = res.status; throw e; }
    return j;
  } finally { if (t) clearTimeout(t); }
}

export const devApi = {
  status: () => api('/dev/status', { timeout: 6000 }),
  register: (pin) => api('/dev/register', { method: 'POST', body: { pin } }),
  login: (pin) => api('/dev/login', { method: 'POST', body: { pin } }),
  changePin: (current, next) => api('/dev/change-pin', { method: 'POST', body: { current, new: next }, auth: true }),
};

export const storeApi = {
  list: (params = {}) => api(`/store/games?${new URLSearchParams(Object.entries(params).filter(([, v]) => v))}`, { timeout: 10000 }),
  categories: () => api('/store/categories', { timeout: 10000 }),
  get: (id) => api(`/store/games/${id}`, { timeout: 15000, auth: !!devToken.get() }),
  play: (id) => api(`/store/games/${id}/play`, { method: 'POST' }),
  liked: (id, cid) => api(`/store/games/${id}/liked?client_id=${cid}`),
  like: (id, cid) => api(`/store/games/${id}/like`, { method: 'POST', body: { client_id: cid } }),
  scores: (id) => api(`/store/games/${id}/scores`),
  addScore: (id, nickname, score) => api(`/store/games/${id}/scores`, { method: 'POST', body: { nickname, score } }),
  mine: () => api('/store/mine', { auth: true }),
  publish: (body) => api('/store/publish', { method: 'POST', body, auth: true }),
  unpublish: (id) => api(`/store/games/${id}`, { method: 'DELETE', auth: true }),
};

export const coverUrl = (g) => (g.has_cover ? `${API}/store/cover/${g.id}?v=${g.version || 1}` : null);

export const playerApi = {
  me: () => api('/auth/me'),
  providers: () => api('/auth/providers', { timeout: 8000 }),
  apple: (code) => api('/auth/apple/exchange', { method: 'POST', body: { code } }),
  register: (email, password, name) => api('/auth/register', { method: 'POST', body: { email, password, name } }),
  login: (email, password) => api('/auth/login', { method: 'POST', body: { email, password } }),
  google: (session_id) => api('/auth/google/session', { method: 'POST', body: { session_id } }),
  logout: () => api('/auth/logout', { method: 'POST' }),
  characters: () => api('/player/characters'),
  buy: (id) => api(`/player/characters/${id}/buy`, { method: 'POST' }),
  select: (id) => api(`/player/characters/${id}/select`, { method: 'POST' }),
  startRun: (game_id) => api('/player/runs', { method: 'POST', body: { game_id } }),
  rewards: (game_id, score, coins, run_id) => api('/player/rewards', { method: 'POST', body: { game_id, score, coins, run_id } }),
};

export function clientId() {
  let c = localStorage.getItem('titan.client');
  if (!c) { c = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now()); localStorage.setItem('titan.client', c); }
  return c;
}
